var PaymentMethodStatusCodeEnum;
(function (PaymentMethodStatusCodeEnum) {
    PaymentMethodStatusCodeEnum["ACTIVE"] = "ACTIVE";
    PaymentMethodStatusCodeEnum["EXPIRES_NEXT_MONTH"] = "EXPIRES_NEXT_MONTH";
    PaymentMethodStatusCodeEnum["EXPIRES_THIS_MONTH"] = "EXPIRES_THIS_MONTH";
    PaymentMethodStatusCodeEnum["EXPIRED"] = "EXPIRED";
    PaymentMethodStatusCodeEnum["REVOKED"] = "REVOKED";
})(PaymentMethodStatusCodeEnum || (PaymentMethodStatusCodeEnum = {}));
export default PaymentMethodStatusCodeEnum;
//# sourceMappingURL=PaymentMethodStatusCodeEnum.js.map